(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (document.querySelector('[data-ravin-immersive-hero]')) {
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ravin-collection-portal"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new WeakMap();
  const clamp = v => Math.max(0, Math.min(1, v));
  const smooth = (a, b, v) => {
    const t = clamp((v - a) / (b - a));
    return t * t * (3 - 2 * t);
  };
  const checkSkipped = () => {
    const params = new URLSearchParams(window.location.search);
    return Array.from(params.entries()).some(([key, value]) => {
      if (key === 'filter.v.availability' && value === '1') return false;
      if (key === 'sort_by') return false;
      if (key === 'page' || key === 'ravin_page') return Number(value) > 1;
      return key.startsWith('filter.') || key.startsWith('ravin.price.') || key.startsWith('page_');
    });
  };
  function init(section) {
    if (instances.has(section)) return;
    const scene = section.querySelector('[data-rpor-scene]');
    const stage = section.querySelector('[data-rpor-stage]');
    const runway = section.querySelector('[data-rpor-runway]');
    const title = section.querySelector('[data-rpor-title]');
    const cards = Array.from(section.querySelectorAll('[data-rpor-card]'));
    const meta = section.querySelector('[data-rpor-meta]');
    const gesture = section.querySelector('[data-rpor-gesture]');
    const handoff = section.querySelector('[data-rpor-handoff]');
    if (!scene || !stage || !runway || !title || !cards.length) return;
    if (checkSkipped() && !window.Shopify?.designMode) { section.hidden = true; return; }
    const media = window.matchMedia('(prefers-reduced-motion: reduce)');
    let raf = 0;
    let active = true;
    let start = 0;
    let travel = 1;
    let latest = -1;
    const refresh = () => {
      const rect = runway.getBoundingClientRect();
      start = rect.top + window.scrollY;
      travel = Math.max(1, runway.offsetHeight - stage.offsetHeight);
    };
    const draw = () => {
      raf = 0;
      if (!section.isConnected || media.matches || !active) return;
      const p = clamp((window.scrollY - start) / travel);
      if (Math.abs(p - latest) < .001) return;
      latest = p;
      const mobile = window.matchMedia('(max-width:749px)').matches;
      const spreadFactor = mobile ? 1 : 1.28;
      const enter = smooth(.06, .37, p);
      const fan = smooth(.22, .53, p);
      const depart = smooth(.76, .98, p);
      const centerOpacity = smooth(.08, .30, p) * (1 - smooth(.90, 1, p));
      const leftOpacity = smooth(.24, .46, p) * (1 - smooth(.80, .99, p));
      const rightOpacity = smooth(.31, .53, p) * (1 - smooth(.79, .99, p));
      const revealCard = (card, transform, opacity) => {
        if (!card) return;
        card.style.transform = transform;
        card.style.opacity = String(clamp(opacity));
        card.style.visibility = opacity > .035 ? 'visible' : 'hidden';
        card.style.pointerEvents = opacity > .8 ? 'auto' : 'none';
      };
      revealCard(
        cards[0],
        'translate(-50%,-50%) translate3d(0,' + (22 - 22 * enter + 90 * depart) + 'px,' + (-190 + 275 * enter - 130 * depart) + 'px) rotateY(' + (-16 + 16 * enter) + 'deg) scale(' + (.66 + .34 * enter + .95 * depart) + ')',
        centerOpacity
      );
      revealCard(
        cards[1],
        'translate(-50%,-50%) translate3d(' + (-10 - 62 * fan * spreadFactor - 100 * depart * spreadFactor) + '%,' + (35 - 30 * fan) + 'px,' + (-245 + 170 * fan) + 'px) rotateY(' + (-8 - 19 * fan) + 'deg) rotateZ(' + (-4 - 8 * fan) + 'deg) scale(' + (.55 + .30 * fan + .2 * depart) + ')',
        leftOpacity
      );
      revealCard(
        cards[2],
        'translate(-50%,-50%) translate3d(' + (10 + 62 * fan * spreadFactor + 100 * depart * spreadFactor) + '%,' + (30 - 28 * fan) + 'px,' + (-225 + 180 * fan) + 'px) rotateY(' + (8 + 19 * fan) + 'deg) rotateZ(' + (4 + 8 * fan) + 'deg) scale(' + (.55 + .30 * fan + .2 * depart) + ')',
        rightOpacity
      );
      const typeMotion = smooth(.05, .57, p);
      const typeExit = smooth(.54, .90, p);
      title.style.transform = 'translate(-50%,-50%) translate3d(0,' + ((mobile ? -105 : -115) * typeMotion) + 'px,' + (160 - 125 * typeMotion) + 'px) rotateX(' + (-7 - 15 * typeMotion) + 'deg) scale(' + (1 - .18 * typeMotion) + ')';
      title.style.opacity = String(1 - smooth(.62, .83, p));
      const titleLines = title.querySelectorAll('.rpor-type-line');
      if (titleLines[0]) titleLines[0].style.transform = 'translate3d(' + (-55 * typeExit) + 'px,' + (-12 * typeExit) + 'px,' + (175 * typeExit) + 'px) rotateY(' + (-28 * typeExit) + 'deg)';
      if (titleLines[1]) titleLines[1].style.transform = 'translate3d(' + (55 * typeExit) + 'px,' + (12 * typeExit) + 'px,' + (155 * typeExit) + 'px) rotateY(' + (28 * typeExit) + 'deg)';
      const depthLabel = scene.querySelector('.rpor-depth-label');
      if (depthLabel) depthLabel.style.opacity = String(clamp(1 - p * 1.7));
      if (meta) meta.style.opacity = String(clamp(1 - p * 1.9));
      if (gesture) gesture.style.opacity = String(clamp(1 - p * 2.5));
      const exit = section.querySelector('[data-rpor-exit]');
      if (exit) exit.style.transform = 'translateY(' + (101 * (1 - smooth(.87, 1, p))) + '%)';
      if (handoff) {
        handoff.style.opacity = String(smooth(.93, 1, p));
        handoff.style.transform = 'translateY(' + (15 * (1 - smooth(.93, 1, p))) + 'px)';
      }
    };
    const schedule = () => { if (!raf && active && !media.matches) raf = window.requestAnimationFrame(draw); };
    const resize = () => { refresh(); latest = -1; schedule(); };
    const watch = new IntersectionObserver(entries => {
      active = entries[0]?.isIntersecting ?? false;
      if (active) { refresh(); latest = -1; schedule(); }
    }, {rootMargin:'120px 0px'});
    watch.observe(section);
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',resize,{passive:true});
    const onMotion = () => { latest = -1; resize(); };
    media.addEventListener?.('change',onMotion);
    refresh();
    schedule();
    instances.set(section,() => {
      window.removeEventListener('scroll',schedule);
      window.removeEventListener('resize',resize);
      media.removeEventListener?.('change',onMotion);
      watch.disconnect();
      if (raf) window.cancelAnimationFrame(raf);
      instances.delete(section);
    });
  }
  const mount = root => {
    if (root.matches?.('[data-rpor]')) init(root);
    root.querySelectorAll?.('[data-rpor]').forEach(init);
  };
  const unmount = root => {
    if (root.matches?.('[data-rpor]')) instances.get(root)?.();
    root.querySelectorAll?.('[data-rpor]').forEach(n => instances.get(n)?.());
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>mount(document),{once:true});
  else mount(document);
  document.addEventListener('shopify:section:load',event => mount(event.target));
  document.addEventListener('shopify:section:unload',event => unmount(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
